import React, { FC, useEffect } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const UkProcessAgentForm: FC<FormProps> = props => {
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = ({data, options, configData, setConfigData}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options, configData, setConfigData })
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    configData,
  } = useForm(
    props.fetchedData,
    config({ countryTelephoneCodes: dropdownOptions.countryTelephoneCodes }),
    submitForm
  )

  useEffect(() => {
    toggleShowByName('weAgreeAppointment',
      formData.inUK.value === 'false'
    )
    toggleShowByName('weAgreeElemental',
      formData.inUK.value === 'false'
    )
    toggleShowByName('weAgreeProvideContactInformation',
      formData.inUK.value === 'false'
    )
    toggleShowByName('weAgreeSucdenToPayFees',
      formData.inUK.value === 'false'
    )

    toggleShowByName('companyName',
      formData.inUK.value === 'false'
    )
    toggleShowByName('companyNumber',
      formData.inUK.value === 'false'
    )
    toggleShowByName('registeredOffice',
      formData.inUK.value === 'false'
    )
    toggleShowByName('addressIsDifferent',
      formData.inUK.value === 'false'
    )
    toggleShowByName('contactName',
      formData.inUK.value === 'false'
    )
    toggleShowByName('contactEmailAddress',
      formData.inUK.value === 'false'
    )
    toggleShowByName('contactPhoneNumber',
      formData.inUK.value === 'false'
    )
    toggleShowByName('contactPhoneNumberCountryIndex',
      formData.inUK.value === 'false'
    )
  },[formData.inUK.value])

  useEffect(() => {
    toggleShowByName('correspondenceAddress',
      formData.addressIsDifferent.value === 'true'
    )
  },[formData.addressIsDifferent.value])

  const isDisableByCheckbox = () => ['weAgreeAppointment','weAgreeElemental','weAgreeProvideContactInformation','weAgreeSucdenToPayFees']
  // @ts-ignore
    .some(item => formData[`${item}`].value === false)

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.UkProcessAgentForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.UkProcessAgentForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation || isDisableByCheckbox()}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default UkProcessAgentForm
